"use client";

import { LayoutContent } from "components/Layout";
import Page from "containers/Page";
import ProductFilteredList from "containers/ProductFilteredList";
import { UseProductFilteredListCreateContextParams } from "containers/ProductFilteredList/hooks";
import { PlaceQuery } from "gql";
import { useProductUrlGenerator } from "hooks/useProductUrlGenerator";

export type PlacePageProps = {
    place: NonNullable<PlaceQuery["place"]>;
};
export function PlacePage({ place }: PlacePageProps) {
    const productUrlGenerator = useProductUrlGenerator();

    const filter = { placeId: place.id };

    const treeIds: UseProductFilteredListCreateContextParams["treeIds"] = [
        "CATEGORY",
        "ATTRIBUTE",
        "PROVIDER",
        "PRICE",
    ] as const;
    const searchTerm = place.name;

    return (
        <Page type="Place" itemId={place.id} title={place.name} allowHeaderTransparency={false}>
            <LayoutContent>
                <ProductFilteredList
                    filter={filter}
                    treeIds={treeIds}
                    searchTerm={searchTerm}
                    urlGenerator={productUrlGenerator}
                    showFiltersTree
                />
            </LayoutContent>
        </Page>
    );
}
